<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-form ref="form" lazy-validation>
      <v-layout>
        <h1><span>{{title}}</span></h1>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mx-1" dark @click="save">Сохранить</v-btn>
        <v-btn color="primary" class="mx-1" dark @click="clear">Очистить</v-btn>
        <v-btn color="primary" class="ml-1 mr-0" dark @click="goBack">Вернуться</v-btn>
      </v-layout>
      <v-alert :value="alert" type="success">Вопрос сохранен</v-alert>
      <v-card class="mb-2" v-if="question.files">
        <v-card-text>
          <v-layout wrap>
            <v-flex xs6 v-for="(file, index) in question.files.split(';')" :key="index">
              <v-img
                :src="`/static/images/practice/${file}`"
                width="450"
                :contain="true"
                class="grey lighten-2 mx-auto"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-textarea
                tabindex="1"
                label="Текст"
                v-model="editedItem.text"
                :error-messages="textErrors"
                required
              />
            </v-flex>
            <v-flex xs6 pr-2>
              <v-text-field
                tabindex="2"
                label="Номер"
                v-model.number="editedItem.number"
                type="number"
                :error-messages="numberErrors"
                required
              />
            </v-flex>
            <v-flex xs6 pl-2>
              <v-select
                :items="categories"
                tabindex="3"
                v-model="editedItem.category"
                label="Категория"
                persistent-hint
                :error-messages="categoryErrors"
              />
            </v-flex>
            <v-flex xs12>
              <table class="ef-table">
                <tr v-for="(item, index) in editedItem.answers" :key="item.id">
                  <td>
                    <v-select
                      :items="costs" v-model="item.cost"
                      :error-messages="costErrors[index] ? costErrors[index] : []"
                    />
                  </td>
                  <td>
                    <wysiwyg
                      :error-messages="answersErrors[index] ? answersErrors[index] : []"
                      tabindex="4"
                      :label="'Вариант '+(index+1)"
                      placeholder="Текст ответа"
                      v-model="item.text"></wysiwyg>
                    <div v-if="answersErrors[index]"
                         class="error--text">{{ answersErrors[index] ? answersErrors[index][0] : '' }}
                    </div>
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import CategoryService from '@/services/CategoryService'
import ObjectUtils from '@/utils/ObjectUtils'
import Dialog from '@/components/fragments/Dialog'
import PracticeQuestionService from '@/services/PracticeQuestionService'
import {required, numeric} from 'vuelidate/lib/validators'

export default {
  props: {
    question: Object,
    editing: false
  },
  components: {Dialog},
  data: () => ({
    alert: false,
    inReset: false,
    categories: CategoryService.getList(),
    defaultItem: PracticeQuestionService.getDefaultItem(),
    editedItem: {},
    costs: PracticeQuestionService.getCosts(),
    practiceQuestionService: undefined
  }),
  computed: {
    title () {
      return this.editing ? 'Редактирование вопроса' : 'Добавление вопроса'
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    textErrors () {
      const errors = []
      if (!this.$v.editedItem.text.$dirty) return errors
      !this.$v.editedItem.text.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    numberErrors () {
      const errors = []
      if (!this.$v.editedItem.number.$dirty) return errors
      !this.$v.editedItem.number.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    categoryErrors () {
      const errors = []
      if (!this.$v.editedItem.category.$dirty) return errors
      !this.$v.editedItem.category.required && errors.push('Поле должно быть заполнено.')
      return errors
    },
    answersErrors () {
      const errors = {}
      for (let i = 0; this.$v.editedItem.answers.$each.$iter[i]; i++) {
        let answer = this.$v.editedItem.answers.$each.$iter[i]
        if (!answer.$dirty) continue
        errors[i] = []
        !answer.text.required && errors[i].push('Поле должно быть заполнено.')
      }
      return errors
    },
    costErrors () {
      const errors = {}
      for (let i = 0; this.$v.editedItem.answers.$each.$iter[i]; i++) {
        let answer = this.$v.editedItem.answers.$each.$iter[i]
        if (!answer.$dirty) continue
        errors[i] = []
        !answer.cost.isUnique && errors[i].push('Поле должно быть уникальным.')
      }
      return errors
    }
  },
  methods: {
    save () {
      this.alert = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.practiceQuestionService.saveItem(this.editedItem, this.editing, (data) => {
          if (data.status) {
            this.alert = true
            if (!this.editing) this.clear()
          }
        })
      }
    },
    goBack () {
      this.$router.back()
    },
    clear () {
      this.$v.$reset()
      this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
    }
  },
  created () {
    this.practiceQuestionService = new PracticeQuestionService(this.$store)
    this.editedItem = ObjectUtils.jsonCopy(this.defaultItem)
  },
  watch: {
    question (val) {
      this.editedItem = ObjectUtils.jsonCopy(val)
    }
  },
  validations: {
    editedItem: {
      text: {required},
      number: {required, numeric},
      category: {required},
      answers: {
        $each: {
          text: {required},
          cost: {
            isUnique (value, item) {
              let unique = true
              this.editedItem.answers.forEach(answer => {
                if (answer.id !== item.id && answer.cost === item.cost) unique = false
              })
              return unique
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ef-table {
  width: 100%;

  td:first-child {
    width: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/practice/EditForm.vue